import React from 'react';
import { Translate } from 'react-localize-redux';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { hasPermission } from '../../store/apiWrapper';
import { isRepiWeb } from '../../store/storeFunctions';
import classnames from 'classnames';
import MainHeader from './mainHeader';

import './headersCommon.scss'

class UserDetailsHeader extends React.Component {
    render() {
        return (<>
            <MainHeader label="Common.User" {...this.props} />
            {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', {'tinted' :this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    {
                        this.getTabs().filter(section => !section.permission ||
                                (Array.isArray(section.permission) ? section.permission.every(p => hasPermission(null, p)) : hasPermission(null, section.permission))
                        ).map(section => (
                            <li key={section.route} className={`tab-link ${this.isActiveLink(section.route) ? "is-active" : ""}`}>
                                <NavLink to={`${this.props.match.url}/${section.route}`}>
                                    <Translate id={section.header} />
                                </NavLink>
                                <div className="search-progress-short" style={{ display: this.isActiveLink(section.route) ? "" : "none" }}></div>
                            </li>
                        ))
                    }
                </ul>
            </div>}
        </>)
    }

    isActiveLink(item) {
        return this.props.location.pathname.indexOf(item) >= 0;
    }

    getTabs = () => {
        let tabs = [
            { route: 'info', header: 'Common.Informations' },
            { route: 'reports', header: 'User.ReportsHistory' }
        ];

        if (!isRepiWeb()) {
            tabs = [
                ...tabs,
                { route: 'sharing-groups', header: 'User.SharingGroups', permission: 'UserInfoConsumptionForWholeClient' },
                { route: 'settings', header: 'Report.Settings.Title', permission: 'UserInfoSettingsTab' }
            ]
        }

        return tabs;
    }
}

export default withRouter(UserDetailsHeader);